const isPlainObject = (value) =>
  value && typeof value === "object" && !Array.isArray(value);

export const flattenObject = (value, prefix = "", result = {}) => {
  if (!isPlainObject(value)) {
    if (prefix) result[prefix] = value;
    return result;
  }
  Object.entries(value).forEach(([key, child]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (isPlainObject(child)) flattenObject(child, path, result);
    else result[path] = child;
  });
  return result;
};

const stableValue = (value) => {
  if (value && typeof value === "object") {
    if (Array.isArray(value)) return JSON.stringify(value);
    return JSON.stringify(
      Object.keys(value)
        .sort()
        .reduce((out, key) => ({ ...out, [key]: value[key] }), {}),
    );
  }
  return String(value);
};

export const getDiff = (oldData, newData) => {
  const before = flattenObject(oldData);
  const after = flattenObject(newData);
  return [...new Set([...Object.keys(before), ...Object.keys(after)])]
    .filter((path) => stableValue(before[path]) !== stableValue(after[path]))
    .map((path) => ({ path, before: before[path], after: after[path] }));
};
export const isNoiseField = (path) =>
  /(^|\.)(__v|createdAt|updatedAt)$/.test(path);
